module.exports = __webpack_public_path__ + "img/ondivan_marca_white_slogan.19eba54c.png";